import TableToExcel from "@linways/table-to-excel/dist/tableToExcel";
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

export const ExcelPrint = (name = "excel_name", sheet = "Sheet 1", id) => {
    // eslint-disable-next-line no-undef
    TableToExcel.convert(document.getElementById(id), {
        name: `${name}.xlsx`,
        sheet: {
            name: sheet
        }
    });
}

export const Pdf = (id, isLandscape = true, fileName) => {
    const doc = new jsPDF(isLandscape ? 'landscape' : null,'mm')
    autoTable(doc, {
        html: '#'+id,
        tableWidth:"auto",
        headStyles: {
            fillColor: "#cfe2ff",
            textColor: "#000",
        },
        head: [
            [{ content: 'Text', colSpan: 9, rowSpan: 2, styles: { halign: 'center' } }],
        ],
        // columns:[1,2,3,4,5,6,7,8,9,10,11,12,13,14],
        // bodyStyles: {
        //     cellWidth: 12
        // },
        styles: {
            valign: 'middle',
            halign: 'center',
            fontSize: 9,
            lineColor: '#000',
            lineWidth: 0.0000000001,
            cellPadding: 1,
            tableWidth: 100,
            overflow: 'linebreak'
        },
        columnStyles: { 1: { cellWidth: 50, halign: 'left' } },
    })
    doc.save(fileName + '.pdf')

}